import { Params } from "@angular/router";

export interface BreadCrumb {
  label: string;
  params: Params;
  url: string;
  urlPart?: string;
  type: string;
  isTranslate?: boolean;
  isHide?: boolean,
  queryParams?: object
}
